import { StatInfoService } from 'data/service/stat-info-service';
import { StatInfo, AppState } from 'data/entities/entities';
import { ItemDataService } from "data/service/item-data-service";
import { Item, ChildItemInfo } from "data/entities/entities";
import { observable } from 'aurelia-binding';
import { autoinject, TaskQueue, singleton, LogManager } from 'aurelia-framework';

import { AppStateService } from 'data/service/app-state-service';
import { ChildItemInfoService } from 'data/service/child-item-info-service';
import { MetadataService } from 'data/service/meta-data-service';
import { Subscription, EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { ItemStatusTypes, QuickViewQueryType } from 'core/enums';


@autoinject()
export class Dashboard {

	legend = {
		//Enable chart legend
		visible: false,
		position: "right"
	};

	marker = {
		dataLabel: {
			//Enable data label in the chart 
			visible: true,
			font: { size: 15, color: "white", bold: true }
		}
	};

	size = {
		height: "250px"
	};

	commonSeries =
		{
			type: 'line',
			enableAnimation: true,
			tooltip: { visible: true },
			enableSmartLabels: true,
			marker: {
				shape: 'circle', size: { height: 10, width: 10 },
				visible: true,
				dataLabel: {
					//Enable data label in the chart 
					visible: true,
					font: { size: 15, color: "black", bold: true }
				}
			},

			border: { width: 2 }
		};

	async getStatusItems() {
		this.logger.info("getItemStatusItems()");
		const parameters = {
			//currentDate: new Date().toISOString().slice(0, 10),
			ownershipStatusCode: this.selectedOwnershipStatusForItemStatusQuickView,
			entityStatusType: 'ACTIVE',
			itemType: 'TASK',
			itemStatusSearchOption: this._selectedItemStatusSearchOption
		};
		this.statusItems = await this.childItemInfoService.list(parameters);
	}

	selectedOwnershipStatusForItemStatusQuickViewChanged() {
		this.logger.info('selectedOwnershipStatusForItemQuickViewChanged');
		if (!this.isInitialized) return;
		this.getStatusItems();
		this.appStateService.saveState(this.className, 'selectedOwnershipStatusForItemStatusQuickView', this.selectedOwnershipStatusForItemStatusQuickView);
	}

	selectedOwnershipStatusForDueQuickViewChanged() {
		this.logger.info('selectedOwnershipStatusChanged');
		if (!this.isInitialized) return;
		this.getDueItems();
		this.appStateService.saveState(this.className, 'selectedOwnershipStatusForDueQuickView', this.selectedOwnershipStatusForDueQuickView);
	}

	selectedDueStatusChanged() {
		//this.quickViewQueryType = QuickViewQueryType.DueStatus;
		this.logger.info('selectedDueStatusChanged');
		if (!this.isInitialized) return;
		this.getDueItems();
		this.appStateService.saveState(this.className, '_selectedDueStatus', this._selectedDueStatus);
	}

	itemStatusInfos: [] = [];
	dueStatusInfos: [] = [];
	teamsTaskInfos: [] = [];
	className: string = 'Dashboard'
	logger = LogManager.getLogger(this.className);
	page = { pageSize: 5, currentPage: 1 };
	dueItems: Array<ChildItemInfo>;
	statusItems: Array<ChildItemInfo>;

	@observable selectedOwnershipStatusForStats: string = 'ALL';
	@observable selectedOwnershipStatusForDueStats: string = 'ALL';
	@observable selectedOwnershipStatusForDueQuickView: string = 'ALL';
	@observable selectedOwnershipStatusForItemStatusQuickView: string = 'ALL';

	private _selectedDueStatus: string = "ALL";
	get selectedDueStatus() {
		return this._selectedDueStatus;
	}

	set selectedDueStatus(status: string) {
		this._selectedDueStatus = status;
		this.selectedDueStatusChanged();
	}

	private _selectedItemStatusSearchOption: string = "ALL";
	get selectedItemStatusSearchOption() {
		return this._selectedItemStatusSearchOption;
	}

	set selectedItemStatusSearchOption(status: string) {
		this._selectedItemStatusSearchOption = status;
		this.selectedItemStatusSearchOptionChanged();
	}

	isInitialized: boolean;
	eventSubscriptions: Array<Subscription> = [];
	constructor(private statInfoService: StatInfoService,
		private eventAggregator: EventAggregator,
		private appStateService: AppStateService,
		private childItemInfoService: ChildItemInfoService,
		private metadataService: MetadataService
	) {
		this.logger.info("constructor");
	}

	private unsubscribeFromEvents() {
		for (let entry of this.eventSubscriptions) {
			entry.dispose();
		}
		this.eventSubscriptions = [];
	}

	onDirectoryChanged(payload) {
		this.clearData();
		this.initialize();
	}

	clearData(): any {
		this.dueItems = null;
		this.statusItems = null;
		this.itemStatusInfos = null;
		this.dueStatusInfos = null;
		this.teamsTaskInfos = null;
	}

	subscribeToEvents() {
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.DIRECTORY_CHANGED, payload => {
			this.onDirectoryChanged(payload);
		}));
		this.eventSubscriptions._add(this.eventAggregator.subscribe(AppEvents.MetadataAcquired, payload => {
			this.onMetadataAcquired(payload);
		}));
	}

	onMetadataAcquired(payload) {
		this.initialize();
	}

	async activate() {
		this.subscribeToEvents();
		await this.initialize();
	}

	async initialize() {
		if (this.isInitialized) return;
		if (!this.metadataService.isInitialized) return;//If no metadata, wait for the event to initialize.
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, true);
		await this.appStateService.setAppState(this.className, this);
		//await this.metadataService.getMetadata();
		this.isInitialized = true;
		this.getDueItems();
		this.getStatusItems();
		this.getItemStatusSummary();
		this.getDueStatusSummary();
		this.getTaskAssingedToAllTeams();
		this.eventAggregator.publish(AppEvents.ToggleIsBusyVisiblity, false);
	}

	async deactivate() {
		this.unsubscribeFromEvents();
	}

	async getDueStatusSummary() {
		this.logger.info("getDueStatusSummary()");
		let parameters = {
			currentDate: new Date().toISOString().slice(0, 10),
			ownershipStatusCode: this.selectedOwnershipStatusForDueStats
		};
		this.dueStatusInfos = await this.statInfoService.getDueStatusInfo(parameters);
		this.teamsTaskInfos = await this.statInfoService.getTeamsTaskInfo(parameters);

		this.logger.info("teamsTaskInfos", this.teamsTaskInfos);

		const chart = $("#dueStatusSummaryChart").data("ejChart");
		if (chart) {
			chart.model.series[0].dataSource = this.dueStatusInfos;
			chart.animate(null);
		}

		const chart1 = $("#teamTaskChart").data("ejChart");
		if (chart1) {
			chart1.model.series[0].dataSource = this.teamsTaskInfos;
			chart1.animate(null);
		}
	}

	async getTaskAssingedToAllTeams() {
		//let parameters = {
		//	currentDate: new Date().toISOString().slice(0, 10),
		//	ownershipStatusCode: this.selectedOwnershipStatusForDueStats
		//};
		//this.dueStatusInfos = await this.statInfoService.getDueStatusInfo(parameters);
		//const chart = $("#teamTaskChart").data("ejChart");
		//if (chart) {
		//	chart.model.series[0].dataSource = this.dueStatusInfos;
		//	chart.animate(null);
		//}
	}

	async getItemStatusSummary() {
		this.logger.info("getItemStatusSummary()");
		this.itemStatusInfos = await this.statInfoService.getItemStatusInfo(this.selectedOwnershipStatusForStats);
		const chart = $("#itemStatusSummaryChart").data("ejChart");
		if (chart) {
			chart.model.series[0].dataSource = this.itemStatusInfos;
			chart.animate(null);
		}
	}

	async refresh() {
		this.getDueItems();
	}

	async getDueItems() {

		this.logger.info("getItems()");

		const parameters = {
			currentDate: new Date().toISOString().slice(0, 10),
			ownershipStatusCode: this.selectedOwnershipStatusForDueQuickView,
			dueStatusCode: this._selectedDueStatus,
			entityStatusType: 'ACTIVE',
			itemType: 'TASK',
			quickViewQueryType: QuickViewQueryType.DueStatus,
			itemStatusTypeid: ItemStatusTypes.Open
		};

		this.dueItems = await this.childItemInfoService.list(parameters);

	}


	selectedItemStatusSearchOptionChanged() {
		this.logger.info('selectedItemStatusSearchOptionChanged');
		this.getStatusItems();
		this.appStateService.saveState(this.className, "_selectedItemStatusSearchOption", this._selectedItemStatusSearchOption);
	}

	selectedOwnershipStatusForStatsChanged() {
		this.logger.info('selectedOwnershipStatusForStatsChanged');
		if (!this.isInitialized) return;
		this.getItemStatusSummary();
		this.appStateService.saveState(this.className, 'selectedOwnershipStatusForStats', this.selectedOwnershipStatusForStats);
	}

	selectedOwnershipStatusForDueStatsChanged() {
		this.logger.info('selectedOwnershipStatusForDueStatsChanged');
		if (!this.isInitialized) return;
		this.getDueStatusSummary();
		this.appStateService.saveState(this.className, 'selectedOwnershipStatusForDueStats', this.selectedOwnershipStatusForDueStats);
	}

	edit = { allowEditing: true, allowAdding: true, allowDeleting: true };
	toolbar = { showToolbar: true, toolbarItems: [ej.Grid.ToolBarItems.Add, ej.Grid.ToolBarItems.Edit, ej.Grid.ToolBarItems.Delete, ej.Grid.ToolBarItems.Update, ej.Grid.ToolBarItems.Cancel] };
	validorder = { required: true, number: true };
	validationcustomer = { required: true, minlength: 3 };
	validationdate = { date: true };
	valid = { number: true };
	validationfreight = { range: [0, 1000] };
	editparams = { decimalPlaces: 2 };
	formatfreight = '{0:c2}';
	formatdate = '{0:MM/dd/yyyy hh:mm:ss}';
	dropdown = 'dropdown';
	datetimepicker = ej.Grid.EditingType.DateTimePicker;
	datePicker = ej.Grid.EditingType.DatePicker;
	numeric = ej.Grid.EditingType.Numeric;
	editboolean = ej.Grid.EditingType.Boolean;


}
